export default "__VITE_ASSET__6a1413f6__"